<template>
  <div class="lead-histories-filter">
    <div class="filter-row">
      <div class="filter-item">
        <BSelectBtn
          v-model="selectedHistoryType"
          :items="historyTypeOptions"
          item-text="label"
          item-value="value"
          clearable
          round
          size="small"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { camelCase } from 'lodash';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { HistoryType, CallTarget } from '@/api/openapi';

type TProps = {
  callTarget: CallTarget;
};

defineProps<TProps>();

const i18n = useI18n();

const selectedHistoryType = defineModel<HistoryType>('historyType');

const historyTypeOptions = computed(() => [
  { value: undefined, text: i18n.t('history.historyFilter.all') },
  ...Object.values(HistoryType).map((type) => ({
    value: type,
    text: i18n.t(`history.historyFilter.${camelCase(type)}`),
  })),
]);
</script>

<style lang="scss" scoped>
.lead-histories-filter {
  padding-bottom: 32px;
}

.filter-row {
  display: flex;
  gap: $basespace-300;
  margin-bottom: $basespace-300;

  &:last-child {
    margin-bottom: 0;
  }
}

.filter-item {
  @include m-flex-align-center;

  :deep(.b-select-btn) {
    .b-btn-primary {
      background-color: $basecolor-success;
      border-color: $basecolor-success;
    }
  }
}

:deep(.b-select) {
  width: 100%;
}
</style>
